import notEmptyAttribute from '@model/_shared/validator/notEmptyAttribute'
import isJSON from 'model/_shared/validator/isJSON'

export const validators = {
  serial: notEmptyAttribute,
  tank: notEmptyAttribute,
  location: notEmptyAttribute,
  frequency: notEmptyAttribute,
  usPower: notEmptyAttribute,
  customer: notEmptyAttribute,
  project: notEmptyAttribute,
  measuredData: isJSON,
}

export {
  validators as default,
}
